<template>
  <div class="news-detail-box">
    <div class="banner">
      <img :src="bannerImg" alt="">
    </div>
    <div class="photo-wrap">
      <div class="item" v-for="(item, index) in photoArr" :key="index">
        <img :src="item.albumUrl" alt="" @click="handlePreview(index)">
        <p class="ellipsis-two">{{ filterDesc(item) }}</p>
      </div>
    </div>
    
    <!-- 音乐 -->
    <div @click="handleControl" class="music-wrap">
      <img :class="{'play': isPlay }" :src="isPlay ? musicON : musicOFF" alt="">
      <audio loop preload="auto" id="webAudio" controls autoplay="autoplay" :hidden="true">
        <source src="https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/bgmusic.mp3" type="audio/mpeg" />
      </audio>
    </div>

  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
import { ImagePreview } from 'vant';
import mixinDown from "@/pages/mobile/views/mixin/mixinDown";
export default {
  mixins:[mixinDown],
  data() {
    return {
      isPlay: true,
      photoArr: [],
      bannerImg: `https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/banner_activity.jpg?t=${new Date().getTime()}`,
      musicON: `https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/music_on.png?t=${new Date().getTime()}`,
      musicOFF: `https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/music_off.png?t=${new Date().getTime()}`,
    };
  },
  computed: {
    filterName () {
      return (item) => {
        const locale = this.$store.state.locale
        const str = locale === 'en' ? item.classifyNameEn : item.classifyNameCn
        return str
      }
    },
    filterDesc () {
      return (item) => {
        const locale = this.$store.state.locale
        const str = locale === 'en' ? item.albumNameEn : item.albumNameCn
        return str
      }
    },
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  mounted() {
    this.fetchPhotoList()

    // 自动播放音乐效果，解决微信自动播放问题
    document.addEventListener('touchstart',this.audioAutoPlay,false);
    document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
    let oAudio = document.getElementById('webAudio');
    oAudio.onended = function () {//播放完毕，重新循环播放
      oAudio.load();
      oAudio.play();
    }
  },
  beforeDestroy() {
    this.classifyId1 = ''
    this.classifyId2 = ''
    this.classifyTitle = '全部相册'
  },
  methods: {
    handleControl () {
      const doms = document.getElementById('webAudio')
      this.isPlay ? doms.pause() : doms.play()
      this.isPlay = !this.isPlay
    },
    audioAutoPlay () {
      console.log('auto play')
      let audio = document.getElementById('webAudio');
      this.isPlay = true;
      audio.play();
      document.removeEventListener('touchstart', this.audioAutoPlay);
    },

    handlePreview (index) {
      const imgList = this.photoArr.map(ele => ele.albumUrl)
      ImagePreview({
        images: imgList,
        startPosition: index,
      });
    },

    // 相册列表
    fetchPhotoList(classifyId) {
      this.$commonPromise("get", this.$Api.photoList, {
        classifyId1: classifyId || ''
      }).then((res) => {
        if (res.code === 200) {
          this.photoArr = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.music-wrap {
  position: fixed;
  right: 10%;
  bottom: 10%;
  width: 80px;
  height: 80px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    &.play {
      animation: rotate 10s linear infinite;
    }
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.banner {
  padding: 20px 0;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.photo-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 16px;
  .item {
    width: 350px;
    margin-bottom: 30px;
    img {
      width: 100%;
      height: 350px;
      display: block;
      object-fit: cover;
      border-radius: 4px;
    }
    p {
      font-size: 26px;
      margin-top: 10px;
      color: #666;
    }
  }
}
</style>
